import React, { useState } from "react";
import "./SideMenu.css";

const SideMenu = ({ settings, onSettingChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isNumbersChecked, setIsNumbersChecked] = useState(
    settings.showNumbers
  );
  return (
    <div className="side-menu-container">
      <div className={`side-menu ${isOpen ? "open" : ""}`}>
        <div className="side-menu-content">
          <h3>Clock Settings</h3>

          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={settings.showNumbers}
                onChange={() => onSettingChange("showNumbers")}
              />
              <span className="toggle-label">Numbers</span>
            </label>
          </div>

          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={settings.showSmallTicks}
                onChange={() => onSettingChange("showSmallTicks")}
              />
              <span className="toggle-label">Small Ticks</span>
            </label>
          </div>

          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={settings.showLargeTicks}
                onChange={() => onSettingChange("showLargeTicks")}
              />
              <span className="toggle-label">Large Ticks</span>
            </label>
          </div>

          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={settings.showDigitalTime}
                onChange={() => onSettingChange("showDigitalTime")}
              />
              <span className="toggle-label">Digital Time</span>
            </label>
          </div>
        </div>
      </div>
      <button
        className="side-menu-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle settings menu"
      >
        <i className={`bx ${isOpen ? "bx-x" : "bx-cog"}`}></i>
      </button>
    </div>
  );
};

export default SideMenu;
